import {Component, inject, OnInit} from '@angular/core';
import {AsyncPipe, CommonModule, DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgbModule, NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../shared/not-found/not-found.component";
import {
  AddressType, ConsiderResultStatus, ErmMasterRegType,
  ErmRegMainSearchParamDto, ErmRegMainViewDto, HospitalSubType,
  HospitalType,
  Page, PettitionType, RegSource,
  Zone
} from "../../../../generated-model/model";
import {GtNgDatepickerModule} from "../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {SelectZoneComponent} from "../../../shared/components/select-zone/select-zone.component";
import {
  ProvinceAutocompleteComponent
} from "../../../shared/components/province-autocomplete/province-autocomplete.component";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {HospitalTypeResource} from "../../../service/HospitalTypeResource";
import {CustomUserDataResult} from "../../../types/openid-connect-userinfo";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {SecurityService} from "../../../security/security.service";
import {
  HospitalAutocompleteComponent
} from "../../../shared/components/hospital-autocomplete/hospital-autocomplete.component";
import {ErmRegMainResource} from "../../../service/ErmRegMainResource";
import {ThaiDateTimePipe} from "../../../shared/commons/thai-datetime.pipe";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-right-history',
  standalone: true,
  imports: [
    DecimalPipe,
    FormsModule,
    NgbPagination,
    NotFoundComponent,
    GtNgDatepickerModule,
    SelectZoneComponent,
    ProvinceAutocompleteComponent,
    AsyncPipe,
    NgForOf,
    HospitalAutocompleteComponent,
    NgIf,
    NgbModule,
    CommonModule,
    ThaiDateTimePipe,
  ],
  templateUrl: './right-history.component.html',
  styleUrl: './right-history.component.scss'
})
export class RightHistoryComponent implements OnInit {
  params: ErmRegMainSearchParamDto = {};
  pageData: Page<ErmRegMainViewDto> = {number: 0, size: 10};
  isZone: boolean = false;
  zone: Zone = {};
  hospitalType$: Observable<HospitalType[]>;
  regSource = RegSource;
  pettitionType = PettitionType;
  addressType = AddressType;
  considerResultStatus = ConsiderResultStatus;
  registerType$: Observable<ErmMasterRegType[]>;
  private hospitalTypeResource = inject(HospitalTypeResource);
  private ermRegMainResource = inject(ErmRegMainResource);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);


  ngOnInit(): void {
    this.hospitalType$ = this.hospitalTypeResource.hospitalType$.pipe(map(e => e.filter(e => e.id !== '0')));
    this.registerType$ = this.ermRegMainResource.searchErmMasterRegType();
    this.params.startRegEffDate = "2020-12-23";
    this.params.regSource = 'SRM'
  }

  search(pageNumber : number = 1) {
    if (pageNumber !== undefined && pageNumber !== null) {
      this.pageData.number = pageNumber - 1;
    }
    let criteria: ErmRegMainSearchParamDto = JSON.parse(JSON.stringify(this.params));
    if (criteria.htype) {
      criteria.htype.subTypes = null;
    }
    this.ermRegMainResource.search(criteria, this.pageData.number, this.pageData.size)
      .subscribe(e => {
          this.pageData = e;
        }
      );
  }

  reset() {
    this.pageData = {number: 0, size: 10}
    this.params = {}
    this.params.regSource = 'SRM'
    this.params.startRegEffDate = "2020-12-23";
  }


  selectHospitalType() {
    if (!this.params?.htype) {
      delete this.params.htype;
    }
    delete this.params.hsubType;
  }

  details(item: ErmRegMainViewDto) {
    this.router.navigate(['./detail/', item.id],
      {relativeTo: this.activatedRoute}).then(r => r);
  }

}
